// js/modules/ContactForm.js
export default class ContactForm {
  constructor({
    formSelector,
    successSelector,
    endpoint
  }) {
    this.form = document.querySelector(formSelector);
    this.successMessage = document.querySelector(successSelector);
    this.endpoint = endpoint;

    if (!this.form) return;

    this.bindEvents();
  }

  bindEvents() {
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    event.preventDefault();

    const formData = new FormData(this.form);

    try {
      const response = await fetch(this.endpoint, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        this.onSuccess();
      } else {
        console.error('Erreur FormSubmit', response);
      }
    } catch (error) {
      console.error('Erreur réseau', error);
    }
  }

  onSuccess() {
    this.form.reset();
    this.form.hidden = true;
    if (this.successMessage) {
      this.successMessage.hidden = false;
    }
  }
}